import { pageTitle } from 'ember-page-title';
import { t } from 'ember-intl';
import { transitionTo } from 'pds-witsmlstudio-core/helpers';
import { Users } from 'pds-witsmlstudio-core/components';
import PageLayout from '../components/page-layout';

<template>
  {{pageTitle (t "users.title")}}

  <PageLayout>
    <:content>
      <Users @onClose={{transitionTo "index"}} />
    </:content>
  </PageLayout>
</template>
